// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2EfHR","footer":"ReportModalFilter_footer__3bU72"};